import React, { useState, useEffect } from "react";
import ProdcutService from "api/precision/ProdcutService";
import XmpieService from "api/precision/XmpieService";
import CustomizeForm from "./CustomizeForm";
import CustomizeFabric from "./CustomizeFabric";
import CustomizeSetup from "./CustomizeSetup";
import ProductList from "./ProductList";
import { useAdors } from "context/AdorsContext";
import moment from 'moment';


// To list products: remove pid, keep pcid
// To customize product keep pid, remove category Id
// http://localhost:3000?token=cecbc0d6c7abb0dcb6f609d8ad6c0b09af1dc87da5ff042b373620ca97fdc4ec&cid=2177&sid=12345&pcid=1977&pid=89400
// Form and interactive
// http://localhost:3000/sees?token=cecbc0d6c7abb0dcb6f609d8ad6c0b09af1dc87da5ff042b373620ca97fdc4ec&cid=2177&sid=12345&pcid=&pid=141787
// Current See
// http://localhost:3000/sees?token=cecbc0d6c7abb0dcb6f609d8ad6c0b09af1dc87da5ff042b373620ca97fdc4ec&cid=2177&sid=12345&pcid=2218&fid=2
// http://localhost:3000/sees?token=cecbc0d6c7abb0dcb6f609d8ad6c0b09af1dc87da5ff042b373620ca97fdc4ec&cid=2177&sid=12345&pcid=2218&fid=1
// https://psggo.com/sees?token=cecbc0d6c7abb0dcb6f609d8ad6c0b09af1dc87da5ff042b373620ca97fdc4ec&cid=2177&sid=12345&pcid=2218&fid=1

// Google site key: 6LeSkYcoAAAAACdgG4OKdVWi6X2u-uARngXzGvUn
// Google Secret: 6LeSkYcoAAAAAJrE7JZ01ZvVN6RF6rzQ_kZQlahf


export default function Customize({ useSession, useShoppingCart }) {
  // Reuse shopping cart
  const { addToCart, removeFromCart, updateCartItem, cartItems, emptyCart } = useShoppingCart();
  const { adors, getAdor, getAdorValue, saveAdors, updateAdorValue } = useAdors();

  const { getProfile, saveProfile, logout } = useSession();
  // Customize session
  const [session, setSession] = useState(getProfile());
  // List available products
  const [products, setProducts] = useState(null);
  // Current product
  const [product, setProduct] = useState(null);
  // "interactive", "form", "setup"
  const [customizeMode, setCustomizeMode] = useState("interactive");
  // Validation list
  const [validations, setValidations] = useState(null);

  useEffect(() => {
    document.title = 'Customize Product';
    // if session has productId, customize one product
    if (session.pid) {
      ProdcutService.query(session.pid)
        .then((res) => {
          if (res.data.result == 1) {
            setProduct(res.data.data);
          }
        })
        .catch((error) => {
          console.error("Error fetching product data:", error);
        });

      XmpieService.query(session.pid, 0)
        .then((response) => {
          if (response.data.result == 1) {
            saveAdors(response.data.data);
            console.log(response.data.data);
          }
        })
        .catch((error) => {
          console.error("Error fetching product data:", error);
        });

      XmpieService.list()
        .then((response) => {
          if (response.data.result == 1) {
            setValidations(response.data.data);
          }
        })
        .catch((error) => {
          console.error("Error fetching product data:", error);
        });
    }
    else if (session.pcid) {
      const filter = {
        customer_id: session.cid,
        product_category_id: session.pcid,
        is_active: 1
      };
      ProdcutService.list(filter)
        .then((res) => {
          if (res.data.result == 1) {
            setProducts(res.data.data);
            if (session.cid == 2177) {  // See's candies
              setActiveProduct(144661);
            }
            else {
              setActiveProduct(res.data.data[0].id);
            }
          }
        })
        .catch((error) => {
          console.error("Error fetching product data:", error);
        });
    }
    else {
      const filter = {
        customer_id: session.cid,
        exclude_no_product: 1,
        is_active: 1,
      };
      ProdcutService.list(filter)
        .then((res) => {
          if (res.data.result == 1) {
            setProducts(res.data.data);
            // console.log(res.data.data);
          }
        })
        .catch((error) => {
          console.error("Error fetching product data:", error);
        });
    }
  }, []);

  const handleImageError = (e) => {
    e.stopPropagation();
    e.target.src = '/sees/dist/img/noimages.png';
  };

  const setActiveProduct = (productId) => {
    setSession({ ...session, ["pid"]: productId });
  }

  return (
    <section className="psg">
      {
        // For customize products with same xmpie layout like see's candies box sleeve
        products && <ProductList
          adors={adors}
          session={session}
          products={products}
          cartItems={cartItems}
          setActiveProduct={setActiveProduct}
          addToCart={addToCart}
        />
      }
      {
        product && customizeMode == "interactive" &&
        <CustomizeFabric product={product} adors={adors} getAdor={getAdor} getAdorValue={getAdorValue} updateAdorValue={updateAdorValue} />
      }
      {
        // Single product single layout use CustomizeForm
        product && customizeMode == "form" &&
        <CustomizeForm
          product={product} adors={adors}
          getAdor={getAdor} updateAdorValue={updateAdorValue}
        />
      }
      {
        // To settup loayout 
        product && customizeMode == "setup" &&
        <CustomizeSetup product={product} adors={adors} getAdor={getAdor} getAdorValue={getAdorValue} updateAdorValue={updateAdorValue} />
      }
    </section>
  );
}
